import { useFlag } from "../../../server/optimizely";
import { sidebar2026Width, sidebarWidth } from "../components/sidebar/sidebar-widths";

/**
 * Whether the 2026 sidebar replaces the original. Only once the flag has loaded, so the original
 * shows while it loads.
 */
export const useSidebar2026 = (): boolean => {
  const [enabled, , loaded] = useFlag("cha_4551_dashboard_2026");

  return loaded && enabled;
};

/** The width of whichever sidebar is showing, for laying things out beside it. */
export const useSidebarWidth = (): number => (useSidebar2026() ? sidebar2026Width : sidebarWidth);
